import { PopupConfig } from "@/store/types";
import { est } from "./awor";
import { cloneConfig } from "./config";
export function awpacu() {
  const clonedConfig = cloneConfig();
  clonedConfig.global.showOrderSet = true;

  clonedConfig.census.gridCardClass = "GridCardPacu";

  clonedConfig.body.patientDetailBodyComponent = "PatientDetailPACU";

  const defaultPopupConfig: PopupConfig = {
    graphRanges: [
      { text: "Current Visit", hours: 0 },
      { text: "2 hours", hours: 2 },
      { text: "4 hours", hours: 4 }
    ],
    graphStartingIndex: 0
  };
  clonedConfig.defaultPopupDescription = defaultPopupConfig;

  // Update all Labs to point to index 0 (entire case)
  Object.values(clonedConfig.popups).forEach((popup: any) => {
    if (popup.popupConfig && popup.popupConfig.graphStartingIndex === 2) {
      popup.popupConfig.graphStartingIndex = 0;
    }
  });

  clonedConfig.popups.PatientHandoff.display.or = false;
  clonedConfig.popups.PatientHandoff.display.pacu = true;

  const pagingFields = [
    { key: "who", text: "Who" },
    { key: "delay", text: "Delay" },
    { key: "repage", text: "Re-Page" },
    { key: "repeat", text: "Repeat" },
    { key: "reenable", text: "Snooze" }
  ];

  clonedConfig.help.paging.fields = clonedConfig.help.paging.fields.concat(
    pagingFields
  );

  clonedConfig.body.buttons.LowMapAlert.visible = false;
  clonedConfig.body.buttons.PostOpPainScore.visible = true;

  clonedConfig.labConfigs.push({
    title: "Lactate",
    atom: "lactate",
    popupName: "Lactate"
  });

  clonedConfig.popups.Lactate = {
    component: "GenericRiskAndGraph",
    popupConfig: {
      title: "Lactate",
      graphStartingIndex: 0,
      graphs: [
        {
          title: "Lactate",
          source: "Lactate"
        },
        {
          title: "Bicarbonate",
          source: "Bicarb"
        }
      ]
    }
  };

  clonedConfig.labConfigs.splice(3, 0, est);
  clonedConfig.census.LegendDescription = [
    {
      icon: "alertPhys1.png",
      label: "One or more active physiologic alert(s)"
    },
    {
      icon: "alertPhys2.png",
      label: "One or more severe active physiologic alert(s)"
    },
    {
      icon: "alertPhys3.gif",
      label: "Paging for an active alert"
    },
    { icon: "alertIsolation", label: "Isolation" },
    { icon: "note3.png", label: "Care coordination note is present" },
    { icon: "alertASA4.png", label: "ASA 4" },
    { icon: "alertASA5.png", label: "ASA 5" },
    { icon: "alertVentilator.png", label: "Patient ventilated" },
    { icon: "alertVentilator1.png", label: "High tidal volume" },
    { icon: "alertVentilator2.png", label: "Paging for high tidal volume" },
    { icon: "alertDischarge.png", label: "Discharge criteria met" },
    { icon: "alertPain1.png", label: "Preop pain more than 5" },
    { icon: "alertPain2", label: "Pain up by 2 relative to preop" },
    { icon: "alertEBL", label: "High EBL more than 1,000 cc" },
    { icon: "alertIV18", label: "IV size" },
    { icon: "alertJehovah", label: "Refuse blood transfusions" },
    { icon: "alertIsolation.png", label: "Contact or Isolation Precaution" },
    {
      icon: "alertIsolation2.png",
      label: "High Risk Contact or Isolation Precaution"
    },
    { icon: "alertSettings2", label: "Alert limits has been changed" },
    { icon: "COVID-19_1.png", label: "COVID-19 test missing or inactive." },
    { icon: "COVID-19_2.png", label: "COVID-19 test result negative." },
    { icon: "COVID-19_3.png", label: "COVID-19 test result pending." },
    {
      icon: "COVID-19_4.png",
      label: "COVID-19 test inactive, previously positive."
    },
    { icon: "COVID-19_5.png", label: "COVID-19 test positive." }
  ];

  clonedConfig.census.colorLegend = [
    { label: "Phase I", caseState: 1 },
    { label: "Phase II", caseState: 2 },
    { label: "Floor Wait", caseState: 3 },
    { label: "Patient Out", caseState: 4 }
  ];

  clonedConfig.census.legend = [
    {
      label: "Alert",
      paths: ["alertPhys1", "alertPhys2"]
    },
    {
      label: "Airway Status",
      paths: ["alertETT1", "alertETT2"]
    },
    {
      label: "Isolation",
      paths: ["alertIsolation"]
    },
    {
      label: "Care Note",
      paths: ["note3"]
    },
    {
      label: "ASA Status",
      paths: ["alertASA4", "alertASA5"]
    },
    {
      label: "Ventilated/Tidal Volume",
      paths: ["alertVentilator", "alertVentilator1", "alertVentilator2"]
    },
    {
      label: "Discharge Ready",
      paths: ["alertDischarge"]
    },
    {
      label: "Pain",
      paths: ["alertPain1", "alertPain2"]
    },
    {
      label: "EBL > 1000",
      paths: ["alertEBL"]
    },
    {
      label: "IV Size",
      paths: ["alertIV14", "alertIV18", "alertIV20"]
    },
    {
      label: "Refuses Blood",
      paths: ["alertJehovah"]
    },
    {
      label: "COVID-19 Status",
      paths: [
        "COVID-19_1",
        "COVID-19_2",
        "COVID-19_3",
        "COVID-19_4",
        "COVID-19_5"
      ]
    },
    {
      label: "Paging Limits Changed",
      paths: ["alertSettings2"]
    }
  ];

  clonedConfig.body.bodyValues.brain.visible = false;
  clonedConfig.body.buttons.Handoff.visible = true;

  clonedConfig.popups.ioBalance.display = {
    adjust: false
  };

  clonedConfig.popups.PainScore.display = {
    graph: true
  };

  clonedConfig.census.legend.forEach((item: any) => {
    item.paths = item.paths.map((path: string) => {
      return `${path}.png`;
    });
  });

  return clonedConfig;
}
